module.exports = __webpack_public_path__ + "static/whatsapp-bg-288622cda0f8412931567b22664a8caa.png";